import { useState, type JSX } from "react";

import { Typography } from "antd";

import {
    Section,
    SectionContent,
    SectionHeader,
    SectionLevel,
} from "../Section";

import { OverflowText } from "./OverflowText";
const { Text } = Typography;

interface CollapseTextSectionProps {
    content: React.ReactNode;
    noContentLabel: string;
    maxCollapsedContentHeight?: number;
    titleLabel: string;
    level: SectionLevel;
    id?: string;
    expandLabel: string;
    collapseLabel: string;
}
export function CollapseTextSection({
    content,
    titleLabel,
    noContentLabel,
    maxCollapsedContentHeight = 120,
    level,
    id,
    expandLabel = "Expand",
    collapseLabel = "Collapse",
}: CollapseTextSectionProps): JSX.Element {
    const [collapsed, setCollapsed] = useState(true);

    const handleToggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const renderedContent = content ? (
        content
    ) : (
        <Text type="secondary">{noContentLabel}</Text>
    );
    return (
        <Section id={id} styleVariant="primary">
            <SectionHeader titleLabel={titleLabel} level={level} />
            <SectionContent>
                <OverflowText
                    collapsed={collapsed}
                    onToggle={handleToggleCollapsed}
                    heightPx={maxCollapsedContentHeight}
                    collapseLabel={collapseLabel}
                    expandLabel={expandLabel}
                >
                    <Text type={content ? undefined : "secondary"}>
                        {renderedContent}
                    </Text>
                </OverflowText>
            </SectionContent>
        </Section>
    );
}
